<template>
<div class="page">
    <div class='loginForm'>
        <h3>登录</h3>
        <el-form :model='form' :rules="rule" label-width="80px" ref='form' style='height:140px;'>
            <el-col :span="24" class='flex'>
                <el-form-item prop='loginName' label="用户名：">
                    <el-input v-model='form.loginName' class='flex1' @focus="key='userName'"></el-input>
                </el-form-item>       
            </el-col>
            <el-col :span="24" class='flex'>
                <el-form-item prop='loginPwd' label="密码：">
                    <el-input v-model='form.loginPwd' type="password" class='flex1'  @focus="key='passWord'"></el-input>
                </el-form-item>
            </el-col>
            <!-- <el-col :span="24" >
                <el-form-item prop='vrifyCode' label="验证码：" class='vrifyCode'>
                    <el-input v-model='form.vrifyCode' @focus="key='vrifyCode'"></el-input>
                <img @click="changeImg" :src="img" alt="验证码" />
                </el-form-item>
            </el-col> -->
        </el-form>
        <div style='position:relative;'>
            <el-button type='primary' @click="submit"> 登录</el-button>
            <!-- <i class='el-icon-menu' @click='showkeyBord=!showkeyBord' style='font-size:40px;position:absolute;right:15px;bottom:0;'></i> -->
            <!-- <img src="@/../public/jp.png" @click='showkeyBord=!showkeyBord' alt="" style='width:50px;height:50px;'>  -->
        </div>
    </div>
</div>
</template>

<script>
import base64 from 'js-base64'
export default {
    data() {
        return {
            form: {loginPwd:'',loginName:''},
            img: '',
            keyboards:"",
            showkeyBord:false,
            key:'',
            rule:{
                loginName:[
                    {required: true, trigger: blur,message:'请输入用户名'}
                ],
                loginPwd:[
                    {required: true, trigger: blur,message:'请输入密码'}
                ],
                vrifyCode:[
                    {required: true, trigger: blur,message:'请输入验证码'}
                ]
            }
        }
    },
    components: {
        
    },
    methods: {
        GetKeyVal(val){
            // console.log(val)
            if(val == 'delete'){
                return this.form[this.key] = this.form[this.key].substr(0,this.form[this.key].length-1)
            }
            if(val == 'enter'){
                return this.submit()
            }
            this.form[this.key] +=val
            // console.log(this.form.vrifyCode)
        //    this[key]=val; 
       } ,
        async submit() {
            if(!await this.$check(this.$refs['form'].validate)) return
            const rsp = await this.$http.login(this.form)
            console.log(rsp.code == 200)
            if(rsp.code != 200) return this.$message({message:rsp.message,type:'error'})
            this.$message({message:'登录成功',type:'success'})
            let info = rsp.data.user
            let userType = rsp.data.roles
            sessionStorage.setItem('userInfo',base64.Base64.encode(JSON.stringify(info)))
            sessionStorage.setItem('menu',base64.Base64.encode(JSON.stringify(rsp.data.menu)))
            sessionStorage.setItem('role',base64.Base64.encode(JSON.stringify(rsp.data.roles)))
            if(userType.roleName !='收银员' ) return this.$router.push({name:'index'})
            let menu = [
                {menuUrl:'choseProduct',childrenMenu:''},
                {menuUrl:'payOrder',childrenMenu:''}
            ]
            sessionStorage.setItem('menu',base64.Base64.encode(JSON.stringify(menu)))
            this.$router.push({name:'choseProduct'})
        },
        async changeImg() {

            //    this.img = await this.$http.getVrifyCode()
            let date = new Date().getUTCSeconds()
            this.img = process.env.VUE_APP_HOST+'/sys/getVrifyCode?time='+date
        }
    },
    mounted(){
        document.addEventListener('keydown',(e)=>{
            if(e.keyCode == 13){
                this.submit()
            }
        })
    },
    created() {
        this.changeImg()
        console.log(base64)
    }
}
</script>

<style scoped lang='scss'>
.page {
    height: 100%;
    background: url('../../assets/login.png') no-repeat;
    background-size: cover;
}

.loginForm {
    width: 400px;
    height: 300px;
    padding: 10px 20px;
    position: absolute;
    right: 10%;
    bottom: 30%;
    background-color: #fff;
    text-align:center;
    /deep/ .el-form-item{
        width: 100%;
    }
    .vrifyCode{
        /deep/ .el-input{width: 200px;}
    }
    h3 {
        font-size: 30px;
        line-height: 70px;
    }
    label {
        display: inline-block;
        width: 80px;
    }
    img {
        width: 80px;
    }
    .el-col {
        align-items: center;
    }
    .el-button {
        margin-top: 10px;
        width: 57%;
    }
}
.keyboard{
    position: absolute;
    left: 0;top: 150px;
}
@media screen and (max-width: 1080px) {
    .loginForm{
        width: 300px;
        right: 2%;
        top: 14%;
        .vrifyCode{
        /deep/ .el-input{width: 99px;}
    }
    }
}
</style>
